module.exports = __webpack_public_path__ + "static/media/fruitfuck-klahrk-remix.e65902f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/fruitfuck-klahrk-remix.mp3
// module id = np4D
// module chunks = 0